import React from 'react'
import {Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Modal, Row} from "reactstrap";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import {common_strings} from "../../translations/common_translations";
import resourceHelper from "../../helpers/ResourceHelper";
import Select from "react-select";
import localeHelpers from "../../helpers/LocaleHelper";
import categoryHelpers from "../../helpers/CategotyHelper";
import paymentTypeHelpers from "../../helpers/PaymentTypeHelper";
import businessHelper from "../../helpers/BusinessHelper";
import dateHelpers from "../../helpers/DateHelper";
import PartnerSearch from "../Search/PartnerSearch";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class EditIncomeView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            income: props.income || resourceHelper.emptyIncome(),
            type: props.type,
            partner: props.partner,
            inputsUpdated: true,
            validation: {
                title: true,
            }
        };
    }

    handleChange = this.handleChange.bind(this);

    handleChange(event) {

        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-title":
                this.setState(prevState => ({
                    income: {
                        ...prevState.income,
                        title: newValue
                    }
                }));
                break;
            case "input-date":
                this.setState(prevState => ({
                    income: {
                        ...prevState.income,
                        date: newValue
                    }
                }));
                break;
            case "input-price":
                const updatedPrice = parseFloat(newValue.replace(/,/g, '-.'));
                this.setState(prevState => ({
                    income: {
                        ...prevState.income,
                        price: updatedPrice
                    }
                }));

                break;
            case "input-qty":
                this.setState(prevState => ({
                    income: {
                        ...prevState.income,
                        qty: parseInt(newValue) >= 0 ? newValue : 0
                    }
                }));

                break;
            case "input-partner-name":

                this.setState(prevState => ({
                    partner: {
                        ...prevState.partner,
                        name: newValue
                    }
                }));
                break;
            case "input-partner-id":

                this.setState(prevState => ({
                    partner: {
                        ...prevState.partner,
                        dni: newValue
                    }
                }));
                break;
            case "input-partner-email":

                this.setState(prevState => ({
                    partner: {
                        ...prevState.partner,
                        email: newValue
                    }
                }));
                break;
            case "input-partner-address":
                this.setState(prevState => ({
                    partner: {
                        ...prevState.partner,
                        address: newValue
                    }
                }));
                break;
            default:
                return
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.income !== this.props.income) {
            this.setState({
                income: nextProps.income,
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.income !== this.state.income) {
            this.handleValidation();
        }
    }

    render() {
        this.localize();

        return (
            <>
                {this.state.showStudentsModal &&
                this.renderStudentSearchModal()
                }
                <div className="bg-secondary">
                    <Form onSubmit={this.handleSubmit}>
                        {this.state.income &&
                        <div className="pl-lg-4">
                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label text-capitalize"
                                        >
                                            {resourceStrings.category}
                                        </label>
                                        <Row>
                                            <Col lg="12">
                                                <Select
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)'
                                                    }}
                                                    className="form-control-alternative"
                                                    placeholder={commonStrings.select}
                                                    value={this.getCategory()}
                                                    onChange={this.handleCategorySelected.bind(this)}
                                                    options={categoryHelpers.categories()}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-title"
                                        >
                                            {resourceStrings.title}
                                        </label>
                                        <Input
                                            placeholder={resourceStrings.title}
                                            className={this.state.validation.title === true ? "form-control-alternative" : "is-invalid"}
                                            onChange={this.handleChange}
                                            defaultValue={this.state.income.title}
                                            id="input-title"
                                            type="text"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="3">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-price"
                                        >
                                            {resourceStrings.amount} ({businessHelper.currency()})
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            defaultValue={this.state.income.price || 0}
                                            id="input-price"
                                            min="0"
                                            type="number"
                                            pattern="^\d+(?:\.\d{1,2})?$"
                                            placeholder="0.00"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="2">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-qty"
                                        >
                                            {resourceStrings.qty}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            defaultValue={this.state.income.qty}
                                            id="input-qty"
                                            min="0"
                                            type="number"
                                            placeholder="0.00"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="7">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                        >
                                            Payment method
                                        </label>
                                        <Row>
                                            <Col lg="10">
                                                <Select
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)'
                                                    }}
                                                    placeholder={commonStrings.select}
                                                    className="form-control-alternative"
                                                    value={this.getPaymentMethod()}
                                                    onChange={this.handlePaymentMethodSelected.bind(this)}
                                                    options={paymentTypeHelpers.paymentTypes()}
                                                />
                                            </Col>
                                            <Col lg="2">
                                        <span className="btn-inner--icon">
                                               <img
                                                   width={24}
                                                   height={24}
                                                   alt="pm"
                                                   src={this.getPaymentMethodIcon()}
                                               />
                                         </span>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-date"
                                        >
                                            {commonStrings.date}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange.bind(this)}
                                            defaultValue={dateHelpers.databaseDate(new Date(this.state.income.date))}
                                            id="input-date"
                                            type="date"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <hr style={{backgroundColor: "lightblue", marginLeft: 20, marginRight: 50}}/>

                            <label
                                style={{width: '100%'}}
                                className="text-center form-control-label mt-2 text-muted">
                                {resourceStrings.invoices.invoice_data}</label>

                            <Row>
                                <Col lg="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-partner-name"
                                        >
                                            {resourceStrings.title} / {commonStrings.name}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            value={this.state.partner ? this.state.partner.name : ""}
                                            id="input-partner-name"
                                            placeholder={`${resourceStrings.title} / ${commonStrings.name}`}
                                            type="text"
                                        />
                                    </FormGroup>

                                </Col>
                                <Col lg="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label text-white"
                                        >
                                            {"."}
                                        </label>
                                        <Row className="ml-0">
                                            <Button
                                                color="info"
                                                onClick={e => this.toggleStudentsModal()}
                                                size="sm"
                                            >
                                                {resourceStrings.invoices.select_partner}
                                            </Button>
                                        </Row>
                                    </FormGroup>

                                </Col>
                            </Row>

                            <Row>
                                <Col lg="8">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-partner-address"
                                        >
                                            {commonStrings.address}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            value={this.state.partner ? this.state.partner.address : ""}
                                            id="input-partner-address"
                                            placeholder={commonStrings.address}
                                            type="text"
                                        />
                                    </FormGroup>
                                </Col>

                                <Col lg="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-partner-id"
                                        >
                                            {commonStrings.id_number}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            value={this.state.partner ? this.state.partner.dni : ""}
                                            id="input-partner-id"
                                            placeholder={`XXX-000`}
                                            type="text"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-partner-email"
                                        >
                                            {commonStrings.email}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            value={this.state.partner ? this.state.partner.email : ""}
                                            id="input-partner-email"
                                            placeholder={commonStrings.address}
                                            type="text"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <small
                                className="text-white mt--2">*{resourceStrings.invoices.data_saved_expl}</small>

                        </div>
                        }

                        <Row className="custom-control custom-control-alternative custom-checkbox mb-3">
                            <Col lg="12" style={{marginLeft: 24}}>
                                <input
                                    className="custom-control-input"
                                    id="save-invoice-cb"
                                    onChange={e => this.handleSaveInvoiceCheckbox(e)}
                                    checked={this.state.saveInvoice}
                                    type="checkbox"
                                />
                                <label className="custom-control-label" htmlFor="save-invoice-cb">
                                    {resourceStrings.save_invoice}
                                </label>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="12">
                                <Col className="text-right">
                                    {this.state.income.id &&
                                    <Button
                                        color="danger"
                                        outline="button"
                                        size="lg"
                                        onClick={e => this.props.deleteIncome(e, this.state.income)}
                                    >
                                        {commonStrings.delete}
                                    </Button>
                                    }
                                    <Button
                                        color="warning"
                                        outline="button"
                                        size="lg"
                                        onClick={e => this.props.closeEditIncomeView(e)}
                                    >
                                        {commonStrings.close}
                                    </Button>

                                    <Button
                                        color={this.validationCleared() ? "default" : "secondary"}
                                        disabled={!this.validationCleared()}
                                        size="lg"
                                        onClick={e => this.props.updateIncome(e, this.state.income, this.state.partner, this.state.saveInvoice)}
                                    >
                                        {commonStrings.save}
                                    </Button>
                                </Col>
                            </Col>
                        </Row>

                    </Form>
                </div>
            </>
        )
    }

    toggleStudentsModal = state => {
        this.setState({
            showStudentsModal: !this.state.showStudentsModal
        });
    };

    renderStudentSearchModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showStudentsModal}
                toggle={() => this.toggleStudentsModal()}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.invoices.select_partner}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <PartnerSearch
                                closeStudentSearchView={this.closeStudentSearchView.bind(this)}
                                addStudent={this.onPartnerSelected.bind(this)}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    closeStudentSearchView(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({
            showStudentsModal: false
        });
    }

    onPartnerSelected(partner) {
        this.setState(prevState => ({
            showStudentsModal: false,
            partner: partner
        }));
    }

    handleCategorySelected = selectedOption => {
        this.setState(prevState => ({
            income: {
                ...prevState.income,
                category: selectedOption.value
            }
        }));
    };

    handlePaymentMethodSelected = selectedOption => {
        this.setState(prevState => ({
            income: {
                ...prevState.income,
                pt: selectedOption.value
            }
        }));
    };

    getCategory() {
        let c = categoryHelpers.categories().find(p => p.value === this.state.income.category);
        return c ? c : categoryHelpers.notDefined();
    }

    validateTitle() {

        const title = this.state.income.title || "";

        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                title: title.length >= 0
            }
        }));
    }

    handleValidation() {
        this.validateTitle();
    }

    validationCleared() {
        return this.state.income.title && this.state.income.title.length > 0
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    getPaymentMethod() {
        let pm = paymentTypeHelpers.paymentTypes().find(p => p.value === this.state.income.pt);

        return pm ? pm : paymentTypeHelpers.notDefined()
    }

    getPaymentMethodIcon() {
        const pt = paymentTypeHelpers.paymentTypes().find(p => p.value === this.state.income.pt);
        return pt ? pt.icon : paymentTypeHelpers.notDefined().icon
    }

    handleSaveInvoiceCheckbox(e) {
        this.setState({saveInvoice: e.target.checked})
    }
}

EditIncomeView.propTypes = propTypes;

export default EditIncomeView;